module.exports = __webpack_public_path__ + "img/fun2.461d9dd0.png";